import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { PageHeader } from "@/widgets/page-header"
import { useState } from "react";
import { AccrualReportForm } from "./accrual-report-form";
import { BonusTransactionsReportForm } from "./bonus-transactions-report-form";

type ReportType = 'accrual' | 'bonus-transactions'

export const BonusReportsPage = () => {
    const [reportType, setReportType] = useState<ReportType>('accrual')

    return (
        <div className="_page_container">
            <PageHeader title="Бонусы" />
            <div className="flexbox flex-1">
                <PageSubtitle title="Отчеты" />
                <div className="p-4 flex-1 bg-white rounded-3xl">
                    <div className="flex flex-col h-full">
                        <div className="flex flex-[1_1_auto] flex-col gap-2">
                            <h1 className="font-mediumttf text-lg">СОЗДАНИЕ ОТЧЕТА</h1>
                            
                            <div className="mb-4">
                                <div className="flex gap-4">
                                    <button
                                        type="button"
                                        onClick={() => setReportType('accrual')}
                                        className={`px-6 py-3 rounded-xl font-bold transition ${
                                            reportType === 'accrual'
                                                ? 'bg-color-primary text-white'
                                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                        }`}
                                    >
                                        Отчет по начислениям
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setReportType('bonus-transactions')}
                                        className={`px-6 py-3 rounded-xl font-bold transition ${
                                            reportType === 'bonus-transactions'
                                                ? 'bg-color-primary text-white'
                                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                        }`}
                                    >
                                        Отчет по транзакциям бонусов
                                    </button>
                                </div>                            </div>

                            {reportType === 'accrual' ? (
                                <AccrualReportForm />
                            ) : (
                                <BonusTransactionsReportForm />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}